import React from 'react';
import styled from 'styled-components';
import TextArea from 'antd/es/input/TextArea';
interface TextAreaSuggestionsProps {
  value?: string;
  onChange?: (value: string) => void;
  suggestions?: string[];
  placeholder?: string;
  rows?: number;
}

const TextAreaSuggestions: React.FC<TextAreaSuggestionsProps> = ({
  value,
  onChange,
  suggestions = [],
  placeholder = 'Type here...',
  rows = 4,
}) => {


  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = e.target.value;
    onChange?.(newValue);
  };

  const handleSuggestionClick = (suggestion: string) => {
    const newValue = value + ' ' + suggestion;
    onChange?.(newValue);
  };

  return (
    <Container>
      <TextArea
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        rows={rows}
        className="text-area"
      />
      {suggestions.length > 0 && (
        <SuggestionsContainer>
          {suggestions.map((suggestion, index) => (
            <SuggestionButton
              type='button'
              key={index}
              onClick={() => handleSuggestionClick(suggestion)}
            >
              {suggestion}
            </SuggestionButton>
          ))}
        </SuggestionsContainer>
      )}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .text-area {
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
`;

const SuggestionsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

const SuggestionButton = styled.button`
  display: flex;
  padding: 8px 24px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 100px;
  border: 1px solid #4384FF;
  background: #FFF;
  color: #4384FF;
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #4384FF;
    color: #FFF;
  }
`;

export default TextAreaSuggestions;